import Address from "@/models/address/Address";
import {isEmpty} from "@/helpers/functions_asi";

export default class AddressBilling extends Address {

	public emailBills!: boolean;

	public static hasEnoughInformationForBilling(address: AddressBilling): boolean {
		if (address.emailBills && isEmpty(address.emails)) {
			return false;
		}

		if ((isEmpty(address.firstname) || isEmpty(address.lastname)) && isEmpty(address.company)) {
			return false;
		}
		if (isEmpty(address.street) && isEmpty(address.address1)) {
			return false;
		}
		if (isEmpty(address.zip) || isEmpty(address.city)) {
			return false;
		}
		if (isEmpty(address.countryCode)) {
			return false;
		}

		return true;
	}

}
